import { render, staticRenderFns } from "./NapasSuccess.vue?vue&type=template&id=24f45a1a&"
import script from "./NapasSuccess.vue?vue&type=script&lang=ts&"
export * from "./NapasSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports